import React from 'react'
import PrimaryHead from '../headings/PrimaryHead'
import SecondaryHead from '../headings/SecondaryHead'
import Carousel from '../minute-components/carousel/Carousel'
import PrimaryButton from '../minute-components/forms/buttons/PrimaryButton'
import "./Project.css"
function Project() {
  return (
    <div className='project'>
        <div className='project_left'>
            <SecondaryHead name="Take a look"/>
            <PrimaryHead name="on my projects"/>
            <div className='project_desc'>
                These are some of my key projects developed during the course of learning and practical implementation. These projects incorporates diversified tech stacks and numerous frameworks for an overall learning experience.
            </div>
        </div>
        <div className='project_right'>
            <Carousel/>
        </div>
    </div>
  )
}

export default Project